import styles from './FooterSecondaryNavTablet.scss';

import React, { FC } from 'react';

import { LinkSet } from 'src/api/contentful/contentTypes.cloverdotcom';
import { Grid } from 'src/components/Grid/Grid';
import { FlatEntry } from 'src/services/cms/flattenContentful';
import { componentKeyV2 } from 'src/utils/ComponentKeyV2';

import { FooterLinkSet } from '../FooterLinkSet/FooterLinkSet';
import { columnIndexes } from './FooterSecondaryNavTablet';

export interface FooterSecondaryNavTabletColumnSectionProps {
  item: FlatEntry<LinkSet>;
  sectionIndex: number;
  columnIndex: number;
}

export const FooterSecondaryNavTabletColumnSection: FC<FooterSecondaryNavTabletColumnSectionProps> = ({
  item,
  sectionIndex,
  columnIndex,
}) => {
  const isSectionInColumn = sectionIndex % columnIndexes.length === columnIndex;
  if (!isSectionInColumn) return null;

  return (
    <div className={styles.linkSetContainer}>
      <FooterLinkSet
        entry={item}
        className={styles.linkSet}
        listItemClassName={styles.listItem}
        titleClassName={styles.title}
      />
    </div>
  );
};

FooterSecondaryNavTabletColumnSection.displayName = 'FooterSecondaryNavTabletColumnSection';

export interface FooterSecondaryNavTabletColumnProps {
  items: Array<FlatEntry<LinkSet>>;
  columnIndex: number;
}

export const FooterSecondaryNavTabletColumn: FC<FooterSecondaryNavTabletColumnProps> = ({
  items,
  columnIndex,
}) => {
  return (
    <Grid key={columnIndex} item xs={4}>
      {items.map((entry, index) => (
        <FooterSecondaryNavTabletColumnSection
          key={componentKeyV2(entry, index)}
          item={entry}
          sectionIndex={index}
          columnIndex={columnIndex}
        />
      ))}
  </Grid>
  );
};

FooterSecondaryNavTabletColumn.displayName = 'FooterSecondaryNavTabletColumn';
